<script setup lang="ts">
const path = useRoute().path
if (path.includes('.'))
  navigateTo(path?.replace(/\..+$/, ''))

const storyblokClient = useStoryblokApiV2()
const data = await storyblokClient.getPage()
const pageContent = useState<any>('page-content', () => {})
useStoryblokMeta(data)

const header = computed(() => pageContent.value?.header?.[0] || data?.header?.[0])
function getComponent(component: string) {
  return (component.startsWith('Page') && component !== 'PageBlock') ? component : `Component${component}`
}
onMounted(() => {
  window.scroll(0, 0)
})
</script>

<template>
  <main v-if="data">
    <LazyStoryblokHeader v-if="header?.component === 'Header'" v-bind="header" />
    <LazyStoryblokHeaderSimple v-else-if="header?.component === 'headerSimple'" v-bind="header" />
    <LazyHeaderFinal v-else-if="header?.component === 'HeaderFinal'" v-bind="header" />
    <component :is="header.component" v-else-if="header" v-bind="header" />
    <component v-bind="item" :is="getComponent(item.component)" v-for="item in data.body" :key="item._uid" v-editable="item" />
  </main>
</template>
